export default __webpack_public_path__ + "static/cafe_36078-60718ee420d0e1ce100b6fe073a986cd.png";